module.exports = __webpack_public_path__ + "img/ic-favorites-inactive.e9a6b477.svg";